module.exports = __webpack_public_path__ + "static/media/Discovery-Brand.a5edfee2.svg";